export * from './staff-tile.component';
